import { render } from "./Favourites.vue?vue&type=template&id=2aa7b4ef&scoped=true"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"

import "./Favourites.vue?vue&type=style&index=0&id=2aa7b4ef&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa7b4ef"]])

export default __exports__